import { useMemo } from "react";

import { useSelector } from "react-redux";

import { resolveActiveCrmIntegration } from "app/pages/sales-intelligence/domain/crm-integration/utils/active-crm-integration";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import {
    selectIsCrmNotIntegrated,
    selectIsCrmStatusLoading,
} from "app/pages/sales-intelligence/sub-modules/management/store/selectors/crmSettingsSelectors";
import type { RootState } from "single-spa/store/types";

import useIntegrationCustomFiltersDescriptionQuery from "../query/queries/useIntegrationCustomFiltersDescriptionQuery";
import createCrmCustomFiltersListViewModel from "../services/filters-list-view-model/factory";
import type { ICrmCustomFiltersListViewModel } from "../types/filters-view-model";

export const useCrmCustomFiltersListViewModel = (): ICrmCustomFiltersListViewModel => {
    const { data, isPending } = useIntegrationCustomFiltersDescriptionQuery();

    const activeIntegration = useMemo(() => resolveActiveCrmIntegration(data), [data]);
    const provider = activeIntegration?.integrationName;

    const isNotConnected = useSelector((state: RootState) => selectIsCrmNotIntegrated(state, provider));
    const isConnectionLoading = useSelector((state: RootState) => selectIsCrmStatusLoading(state, provider));

    return useMemo(
        () =>
            createCrmCustomFiltersListViewModel({
                description: data,
                integrationObject: activeIntegration,
                isEnabled: salesSettingsHelper.isCrmCustomFiltersEnabled,
                isNotConnected,
                isLoading: isConnectionLoading || isPending,
            }),
        [data, isPending, isNotConnected, isConnectionLoading, activeIntegration],
    );
};
